import React, { FC } from 'react';
import { View } from 'react-native';
import { AlertTile, FocusableFlatList } from '@components';

import { alertDetailsPageTestIDs, mapPageTestIDs, Theme } from '@constants';
import { useContextNodeHandle, useContextReference } from '@hooks';
import { navigationService } from '@services';
import { AlertsHeadline } from '@store';

import { styles } from './styles';

import { OverlayType, ZoomPreset } from '../../../components/map/Map';
import { showAlerts } from '../helpers';

type MapAlertsRowProps = {
  overlayType: keyof typeof OverlayType;
  zoomPreset: keyof typeof ZoomPreset;
  alerts: AlertsHeadline[];
};

export const MapAlertsRow: FC<MapAlertsRowProps> = ({ alerts, overlayType, zoomPreset }) => {
  const numberOfAlerts = alerts.length;

  const alertListReference = useContextReference(mapPageTestIDs.alertTilesList);
  const changeMapButtonHandle = useContextNodeHandle(mapPageTestIDs.changeMapButton);
  const onAlertTilePress = (index: number) => {
    navigationService.navigate(alertDetailsPageTestIDs.alertDetailsPage, {
      index,
      alerts,
    });
  };

  return numberOfAlerts && showAlerts(overlayType, zoomPreset, alerts) ? (
    <View style={styles.weatherAlertsContentWrapper}>
      <FocusableFlatList
        data={alerts}
        focusPositions={3}
        horizontal
        keyExtractor={(alert: AlertsHeadline) => alert.detailKey}
        nextFocusDown={changeMapButtonHandle}
        paddingEnd={Theme.px(186)}
        paddingStart={Theme.px(84)}
        ref={alertListReference}
        renderItem={(alert: AlertsHeadline, index: number) => (
          <AlertTile.API
            eventDescription={alert?.eventDescription}
            expireTimeUTC={alert.expireTimeUTC}
            index={index}
            issueTimeLocalTimeZone={alert.issueTimeLocalTimeZone}
            testID={`${mapPageTestIDs.alertTile}-${index}`}
            totalAlerts={numberOfAlerts}
            onPress={() => onAlertTilePress(index)}
          />
        )}
        showsHorizontalScrollIndicator={false}
        testID={mapPageTestIDs.alertTilesList}
        wrapItem={false}
      />
    </View>
  ) : (
    // Return an empty list so the alertListReference doesn't go away for future focus navigation.
    <View style={styles.weatherAlertsContentWrapper}>
      <FocusableFlatList importantForAccessibility={'no'} ref={alertListReference} />
    </View>
  );
};
